import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import React from 'react';
import GuideLayout from '../GuideLayout';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const switchColumns = [{
  title: '开关',
  dataIndex: 'switch_name'
}, {
  title: '含义',
  dataIndex: 'meaning'
}, {
  title: '什么时候打开',
  dataIndex: 'when'
}];
const switchData = [{
  switch_name: '是否参与自动算料（MRP）',
  meaning: '打开后，系统会自动计算这个物料的净需求并生成采购/生产任务',
  when: '需要系统自动补货的物料'
}, {
  switch_name: '是否虚拟件',
  meaning: '虚拟件是逻辑上的组合件，只用于搭建 BOM 结构，本身不备货、不入库、不参与算料',
  when: '仅用于描述产品结构的中间层级（如"上机架组件"只是把几个零件组装在一起的概念）'
}, {
  switch_name: '替代料',
  meaning: '为某个主料指定可替代的物料并排好优先级',
  when: '当主料缺货时，系统按优先级提示可用的替代料'
}];
const virtualChart = `graph LR
    A["成品：自动化装配机"] --> B["虚拟件：上机架组件"]
    B --> C["真实件：铝板"]
    B --> D["真实件：电机"]
    B --> E["真实件：传感器"]
    A --> F["真实件：底座"]

    style B fill:#FFF9C4,stroke:#FFC107
    style C fill:#E8F5E9,stroke:#4CAF50
    style D fill:#E8F5E9,stroke:#4CAF50
    style E fill:#E8F5E9,stroke:#4CAF50
    style F fill:#E8F5E9,stroke:#4CAF50`;
const sections = [{
  id: 'switches',
  label: '物料的关键开关'
}, {
  id: 'virtual',
  label: '虚拟件 vs 真实件'
}, {
  id: 'bom',
  label: 'BOM 的版本管理'
}];
export default function Product() {
  return /*#__PURE__*/React.createElement(GuideLayout, {
    title: "\u7814\u53D1/\u4EA7\u54C1\u2014\u2014\u7269\u6599\u4E0E BOM",
    firstQuestion: "\u7269\u6599\u5C5E\u6027\u91CC\u90A3\u4E9B\u5F00\u5173\u662F\u4EC0\u4E48\u610F\u601D\uFF1F",
    sections: sections
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "switches"
  }, /*#__PURE__*/React.createElement("h2", null, "\u7269\u6599\u7684\u5173\u952E\u5F00\u5173"), /*#__PURE__*/React.createElement("blockquote", null, "\u6BCF\u4E2A\u7269\u6599\u6709\u4E09\u4E2A\u91CD\u8981\u5F00\u5173\uFF0C\u76F4\u63A5\u51B3\u5B9A\u7CFB\u7EDF\u5982\u4F55\u5904\u7406\u8FD9\u4E2A\u7269\u6599\u3002"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: switchColumns,
    data: switchData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "virtual"
  }, /*#__PURE__*/React.createElement("h2", null, "\u865A\u62DF\u4EF6 vs \u771F\u5B9E\u4EF6"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: virtualChart
  })), /*#__PURE__*/React.createElement("blockquote", null, /*#__PURE__*/React.createElement("strong", null, "\u865A\u62DF\u4EF6"), "\uFF08\u9EC4\u8272\uFF09\u4E0D\u4F1A\u51FA\u73B0\u5728\u91C7\u8D2D\u4EFB\u52A1\u6216\u5DE5\u5355\u4E2D\uFF0C\u5B83\u53EA\u662F BOM \u7684\u7ED3\u6784\u8282\u70B9\u3002", /*#__PURE__*/React.createElement("strong", null, "\u771F\u5B9E\u4EF6"), "\uFF08\u7EFF\u8272\uFF09\u624D\u4F1A\u88AB\u7CFB\u7EDF\u7B97\u6599\u3001\u91C7\u8D2D\u3001\u5165\u5E93\u3002")), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "bom"
  }, /*#__PURE__*/React.createElement("h2", null, "BOM \u7684\u7248\u672C\u7BA1\u7406"), /*#__PURE__*/React.createElement("blockquote", null, "BOM \u8981\u8D70\u300C\u63D0\u4EA4 \u2192 \u5BA1\u6838 \u2192 \u53D1\u5E03\u300D\u6D41\u7A0B\uFF0C\u53EA\u6709\u53D1\u5E03\u751F\u6548\u7684\u7248\u672C\u624D\u4F1A\u88AB MRP \u4F7F\u7528\u3002"), /*#__PURE__*/React.createElement("h3", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, "\u8BBE\u8BA1\u53D8\u66F4\u65F6", /*#__PURE__*/React.createElement("strong", null, "\u53CA\u65F6\u66F4\u65B0 BOM"), "\uFF0C\u5426\u5219\u7B97\u6599\u548C\u751F\u4EA7\u4F1A\u7528\u9519\u6599"), /*#__PURE__*/React.createElement("li", null, "BOM \u6709\u7248\u672C\u8BB0\u5F55\uFF0C\u5386\u53F2\u7248\u672C\u53EF\u8FFD\u6EAF"), /*#__PURE__*/React.createElement("li", null, "\u751F\u4EA7\u4E2D\u53EF\u901A\u8FC7 ECN \u6D41\u7A0B\u540C\u6B65\u6700\u65B0 BOM"))));
}